import React from 'react';
import { useStore } from '../../stores';
import classNames from 'classnames'

export const Close = ({ action }) => {

const { poi, layers } = useStore();
    
const hideAction = (event) => {
    event.stopPropagation();
    if (event.target === event.currentTarget) {
      poi.setInactive();
      layers.closeLayer();
    }
  };

  return (

    <div onClick={hideAction} className={classNames(
      'bg-neutral-100 w-9 h-9 p-1 cursor-pointer flex justify-center items-center absolute z-10 transition-all hover:bg-neutral-200',
      {
          'top-6 right-6 rounded-tr-md rounded-bl-md' : poi.active?.images?.length,
          'top-[15px] right-[15px] lg:top-0 lg:right-0 rounded-full lg:rounded-none lg:rounded-bl-md' : !poi.active?.images?.length
      })
    }>
      <span className="icon icon-close" onClick={action} />
    </div>
    
  );
  
};